<div class="location-list {{ position }}">
  @if (locations && locations.length) {
    @for (location of locations; track location) {
      <div
        [class.location-selected]="(selectedLocation$ | async)?.name === location.name && allowToPreSelectLocation"
        (click)="selectLocation(location)"
        class="location-list-item"
      >
        @if ((selectedLocation$ | async)?.name === location.name && allowToPreSelectLocation) {
          <i class="selected-indicator" [nimbusIcon]="ICONS.SUCCESS"></i>
        }
        <div class="location-list-item-title">
          <img src="api/manifests/v1/Icon.png" alt="location picture" />
          <p class="flex-container flex-column flex-align-top-left">
            @if (!location.isCurrent) {
              <span>{{ location.name | translate }}</span>
            } @else {
              <span>{{ location.name | translate }} ({{ TranslationKeys.GeoLocationCurrentLocation | translate }})</span>
            }
            @if (position === 'vertical') {
              <span class="location-description">{{ location.description | translate }}</span>
            }
          </p>
        </div>
        @if (position === 'horizontal') {
          <span class="location-description">{{ location.description | translate }}</span>
        }
      </div>
    }
  } @else {
    <div class="location-placeholder">
      <span>{{ TranslationKeys.GeoLocationNoLocationAvailable | translate }}</span>
    </div>
  }
</div>
